export const isEqual = (array1: Array<number>, array2: Array<number>) => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

export const isEqualArrayObjects = (
  arr1: Array<{ id: number; version: number }>,
  arr2: Array<{ id: number; version: number }>,
) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const createComparisonString = (obj: { id: number; version: number }) => `id:${obj.id}-version:${obj.version}`;

  const set1 = new Set(arr1.map(createComparisonString));
  const set2 = new Set(arr2.map(createComparisonString));

  return [...set1].every((element) => set2.has(element));
};
